<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="subpage notification-detail flex-column-start" ref="notificationDetailRef">
    <Header v-if="$route.query.platform !== 'mini'" title="课程详情" :is-sub-page="true" :is-native-handle="true" ref="navBarRef">
      <template v-slot:rightBtn>
        <span class="btn btn-share" @click="shareClick"></span>
      </template>
    </Header>

    <div class="content" ref="contentRef" style="flex: 1; overflow:hidden;">
      <div ref="scrollRef" style="overflow: auto; height: 100%;">
        <section class="wrapper">
          <!--<img src="@/assets/temp/1.png">-->
          <img :src="this.coverUrl" style="object-fit: cover">
          <div class="info">
            <h2>{{this.title}}</h2>
            <p>
              <span class="read">{{this.readNum}}</span>
              <span class="share">{{this.shareNum}}</span>
            </p>
            <p><span class="date"></span>{{this.openDate}}</p>
            <p><span class="address"></span>{{this.address}}</p>
            <p><span class="sign"></span>已报名{{this.signNum}}人<span>/限{{this.signLimit}}人报名</span></p>
          </div>
        </section>

        <section class="desc">
          <div class="ql-snow">
            <div class="h5-web ql-editor" v-html="this.content"></div>
          </div>
        </section>
      </div>
    </div>

    <cube-button class="bottom-btn half-safe-padding" :primary="true" ref="buttonRef" @click="gotoSign">
      立即报名
    </cube-button>
  </div>
</template>

<script>
import Header from '../../../components/Header'
import { queryNotifyDetail, notifyShare } from '@/api/course'
export default {
  name: 'CourseDetail',
  components: {
    Header
  },
  data () {
    return {
      coverUrl: '',
      title: '',
      readNum: '',
      shareNum: '',
      openDate: '',
      address: '',
      signNum: 0,
      signLimit: 0,
      content: ''
    }
  },
  mounted () {
    console.log('课程通知 id:' + parseInt(this.$route.query.id))

    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    setTimeout(() => {
      this.getData()
    }, 500)
  },
  methods: {
    gotoSign () {
      this.$router.push({
        path: 'sign',
        query: {
          id: parseInt(this.$route.query.id),
          // platform: 'mini',
          platform: this.$route.query.platform,
          token: this.$route.query.token
        }
      })
    },
    getData () {
      queryNotifyDetail({
        notifyId: parseInt(this.$route.query.id)
      }).then((res) => {
        this.coverUrl = res.data.cover.resUrl
        this.title = res.data.name
        this.readNum = res.data.readNum
        this.shareNum = res.data.shareNum
        this.openDate = res.data.openTime
        this.address = res.data.address
        this.signNum = res.data.signNum
        this.signLimit = res.data.signLimit
        this.content = res.data.content
      })
    },
    shareClick () {
      console.log('课程通知 share')
      console.log('share  type=' + this.$route.query.type + '  id=' + this.$route.query.id)
      notifyShare({
        notifyId: parseInt(this.$route.query.id)
      }).then((res) => {
        this.$dfzhJsBridge.share({
          url: process.env.VUE_APP_SHARE_URL + '/notification/notification_detail?type=' + this.$route.query.type + '&id=' + this.$route.query.id + '&p=0',
          title: this.title === '' ? ' ' : this.title,
          description: ' '
        })
      })
    }
  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
.notification-detail
  .wrapper
    padding 0
    margin-bottom 10px
    img
      width 100%
      height 210px // 图片不给具体高度，scroll会有问题
    .info
      h2
        font-size 15px
        padding 10px
        color #363636
        text-align left
      p
        padding 10px
        text-align left
        color #363636
        font-size 15px
        span
          color #B8B8B8
          margin-right 20px
          padding-left 22px
        span.read
          font-size 14px
          background url("~@/assets/images/icons/icon-read.png") no-repeat left center
          background-size 17px 17px
        span.comment
          font-size 14px
          background url("~@/assets/images/icons/icon-comment.png") no-repeat left center
          background-size 17px 17px
        span.share
          font-size 14px
          background url("~@/assets/images/icons/icon-share2.png") no-repeat left center
          background-size 17px 17px
        span.date
          background url("~@/assets/images/icons/icon-calendar.png") no-repeat left center
          background-size 22px 22px
          margin-right 4px
        span.address
          background url("~@/assets/images/icons/icon-address.png") no-repeat left center
          background-size 22px 22px
          margin-right 4px
        span.sign
          background url("~@/assets/images/icons/icon-sign.png") no-repeat left center
          background-size 22px 22px
          margin-right 4px
  .desc
    color #363636
    font-size 15px
    line-height 22px
    padding-top 15px
    padding-bottom 15px
    text-align justify
  .h5-web
    img
      width 100%
</style>
